module.exports = __webpack_public_path__ + "img/background.55f9246f.jpeg";